import { render, staticRenderFns } from "./CourseConsumed.vue?vue&type=template&id=0737acb8&scoped=true"
import script from "./CourseConsumed.vue?vue&type=script&lang=js"
export * from "./CourseConsumed.vue?vue&type=script&lang=js"
import style0 from "./CourseConsumed.vue?vue&type=style&index=0&id=0737acb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0737acb8",
  null
  
)

export default component.exports